<wiz-hgroup width="100%" height="100%">
  <full-calendar #fullcalendar *ngIf="readyToGo" 
  style="max-width: unset !important;"
  schedulerLicenseKey='CC-Attribution-NonCommercial-NoDerivatives'
  [options]="calendarOptions"></full-calendar>
</wiz-hgroup>
